import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils/general";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  text?: string;
  fullScreen?: boolean;
}

export function LoadingSpinner({
  className,
  size = "md",
  text = "Loading..."
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  const containerClasses = "flex flex-col items-center justify-center p-8 bg-transparent";

  return (
    <div className={cn(containerClasses, className)}>
      <Loader2 className={cn(
        sizeClasses[size],
        "animate-spin text-on-light",
        !text && "mb-0",
        text && "mb-4"
      )} />
      {text && (
        <p className="text-sm text-on-light-muted">{text}</p>
      )}
    </div>
  );
}

// Simple inline loading spinner for buttons and small areas
export function InlineSpinner({ className }: { className?: string }) {
  return (
    <div className={cn("inline-block", className)}>
      <div className="h-4 w-4 animate-spin rounded-full border-2 border-on-light-muted border-t-on-light" />
    </div>
  );
}